import * as Sentry from '@sentry/vue';
import Vue from 'vue'
// import { loggerMixin } from '../mixins/logger';

export default ({ app, store }, inject) => {
  Sentry.init({
    Vue,
    dsn: process.env.SENTRY_DSN,

    integrations: [
      // Add browser profiling integration to the list of integrations
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),

      Sentry.replayIntegration({
        // Additional SDK configuration goes in here, for example:
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    _experiments: { enableLogs: true },

    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 0.5,
    tracesSampleRate: 0.5,
    profilesSampleRate: 0.5,
    environment: process.env.APP_ENV,
    release: process.env.SENTRY_RELEASE,
    // debug: process.env.APP_ENV === 'development',
  });

  inject('sentry', Sentry);

  if (app.$auth && app.$auth.loggedIn) {
    const user = app.$auth.user;
    Sentry.setUser({
      id: user.id,
      username: user.first_name || user.email,
      email: user.email
    });
  } else {
    Sentry.setUser(null);
  }

  const logger = {
    trace: (message, attributes) => {
      Sentry.logger.trace(message, attributes);
      // eslint-disable-next-line no-console
      console.trace(message, attributes);
    },
    debug: (message, attributes) => {
      Sentry.logger.debug(message, attributes);
      // eslint-disable-next-line no-console
      console.debug(message, attributes);
    },
    info: (message, attributes) => {
      Sentry.logger.info(message, attributes);
      // eslint-disable-next-line no-console
      console.info(message, attributes);
    },
    warn: (message, attributes) => {
      Sentry.logger.warn(message, attributes);
      // eslint-disable-next-line no-console
      console.warn(message, attributes);
    },
    error: (message, error) => {
      Sentry.logger.error(message, { error });
      // eslint-disable-next-line no-console
      console.error(message, error);
    },
    fatal: (message, attributes) => {
      Sentry.logger.fatal(message, attributes);
      // eslint-disable-next-line no-console
      console.error(message, attributes);
    }
  };

  inject('logger', logger);
};
